/* AGC Shipping Policy â€” single source of truth for emirate-keyed thresholds.
 * Phase 0 â€” W6 â€” see plan v1.2.
 * Data is hydrated from the `shipping_tier` Shopify metaobject by snippets/agc-shipping-data.liquid
 * (which writes a JSON <script type="application/json" id="agc-shipping-data"> tag
 * into the rendered page). This module reads that JSON, exposes a typed API, and
 * provides a helper used by the cart drawer free-shipping bar. No hardcoded thresholds.
 */
(function (root) {
  'use strict';

  var STATE = {
    loaded: false,
    tiers: [],          // [{emirate, emirate_handle, delivery_fee_aed, free_threshold_aed, schedule_day, outskirts_list, display_order}]
    byHandle: {},
  };

  function parseTiersFromDOM() {
    var el = document.getElementById('agc-shipping-data');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || el.innerText || '[]');
      if (!Array.isArray(data)) return [];
      return data.map(function (t) {
        return {
          emirate: t.emirate || '',
          emirate_handle: t.emirate_handle || (t.emirate || '').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''),
          delivery_fee_aed: parseInt(t.delivery_fee_aed, 10) || 0,
          free_threshold_aed: parseInt(t.free_threshold_aed, 10) || 0,
          schedule_day: t.schedule_day || '',
          outskirts_list: t.outskirts_list || '',
          display_order: parseInt(t.display_order, 10) || 999,
        };
      }).sort(function (a, b) { return a.display_order - b.display_order; });
    } catch (e) {
      if (window.console && console.warn) console.warn('[agc-shipping-policy] parse error:', e);
      return [];
    }
  }

  function load() {
    if (STATE.loaded) return STATE;
    var tiers = parseTiersFromDOM();
    STATE.tiers = tiers;
    STATE.byHandle = {};
    for (var i = 0; i < tiers.length; i++) {
      STATE.byHandle[tiers[i].emirate_handle] = tiers[i];
    }
    STATE.loaded = tiers.length > 0;
    return STATE;
  }

  // Public API
  var api = {
    getAll: function () { return load().tiers.slice(); },
    getByHandle: function (handle) { return load().byHandle[handle] || null; },

    /**
     * Returns the lowest free-shipping threshold across all tiers (e.g. AED 99).
     * The cart drawer free-shipping bar uses this when no emirate is selected.
     */
    getLowestFreeThreshold: function () {
      var tiers = load().tiers;
      if (!tiers.length) return null;
      return tiers.reduce(function (lo, t) {
        return (t.free_threshold_aed && t.free_threshold_aed < lo) ? t.free_threshold_aed : lo;
      }, Infinity);
    },

    /**
     * Returns delivery cost + ETA copy for the supplied emirate handle and cart subtotal (in AED, not cents).
     */
    quote: function (emirateHandle, subtotalAed) {
      var tier = api.getByHandle(emirateHandle);
      if (!tier) return null;
      var free = subtotalAed >= tier.free_threshold_aed && tier.free_threshold_aed > 0;
      return {
        emirate: tier.emirate,
        delivery_fee_aed: free ? 0 : tier.delivery_fee_aed,
        free_threshold_aed: tier.free_threshold_aed,
        is_free: free,
        schedule_day: tier.schedule_day,
      };
    },

    /** Internal â€” re-read from DOM (useful after dynamic section refresh). */
    refresh: function () { STATE.loaded = false; return load(); },
  };

  root.AGCShippingPolicy = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})(typeof window !== 'undefined' ? window : this);
